import { render, staticRenderFns } from "./SvgDiagonalGeneralCard.vue?vue&type=template&id=20484fcf&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports